import React, { ReactElement, ReactNode } from "react";
import { ListenForCallStatus } from "features/Header/PuzzelTelephone/provider/contexts/ListenForCallStatusContext";
import { CallStatusProvider } from "features/Header/PuzzelTelephone/provider/contexts/CallStatusContext";

type Props = {
  children: ReactNode;
};

export const CallProvider = ({ children }: Props): ReactElement | null => (
  <ListenForCallStatus>
    <CallStatusProvider>{children}</CallStatusProvider>
  </ListenForCallStatus>
);
